import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { TranslateDirective, TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';

import {
  CurrencyPipe,
  HrefDirective,
  IconButtonComponent,
  IconComponent,
  IfFeatureService,
  NotificationsToast,
  NotificationsToastComponent
} from '@tdwb/core';
import { Strategy } from '@tdwb/lazy/trading';
import { OrderNotificationsToast } from '../order-notifications-toast.domain';

/**
 * Order toast notifications toast component
 * Display order notification in notification conatiner
 */

@Component({
  selector: 'td-wb-order-notifications-toast',
  templateUrl: './order-notifications-toast.component.html',
  styleUrls: ['./order-notifications-toast.component.scss'],
  imports: [
    NgTemplateOutlet,
    TranslateDirective,
    NgxTranslatePipe,
    CurrencyPipe,
    HrefDirective,
    IconButtonComponent,
    IconComponent
  ]
})
export class OrderNotificationsToastComponent implements NotificationsToastComponent {
  private readonly featureService = inject(IfFeatureService);

  readonly toast = input.required<OrderNotificationsToast>();
  readonly excessMessageCount = input(undefined as number | undefined);
  readonly onClose = output<NotificationsToast>();

  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly Strategy: typeof Strategy = Strategy;
  readonly newMLONotificationEnabled: boolean;

  constructor() {
    this.newMLONotificationEnabled = this.featureService.getFeatureFlag<boolean>('newMLONotification');
  }

  /**
   * Check if an excess message is shown
   */
  isExcessMessage(): boolean {
    return this.excessMessageCount() !== undefined && this.excessMessageCount() > 0;
  }

  /**
   * Check if the strategy is MLO
   */
  isMLO(): boolean {
    return this.toast().strategy === Strategy.MLO;
  }

  /**
   * Check if the strategy is FTO
   */
  isFTO(): boolean {
    return this.toast().strategy === Strategy.FTO;
  }

  /**
   * Check if the strategy is OTA
   */
  isOTA(): boolean {
    return this.toast().strategy === Strategy.OTA;
  }

  /**
   * Check if the strategy is OCO
   */
  isOCO(): boolean {
    return this.toast().strategy === Strategy.OCO;
  }

  /**
   * Close toast
   */
  close(): void {
    this.onClose.emit(this.toast());
  }

  getMLOPrice(price: number): number {
    return Math.abs(price);
  }

  getColourHighlight(action: string): string {
    if (this.toast().isRejected && (action === 'SELL' || action === 'BUY')) {
      return 'td-wb-notification-toast__text-grey';
    } else if (action === 'SOLD') {
      return 'td-wb-notification-toast__text-red';
    }

    return '';
  }
}
